import React from 'react'
import Reflux from 'reflux'
import { Row, Col } from 'reactstrap'

import CurrentRecipeStore from '~/stores/currentRecipe.js'


export default class RecipeDetailsYield extends Reflux.Component {
	constructor(props) {
		super(props)

		this.store = CurrentRecipeStore
		this.storeKeys = ['servings']
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	render() {
		return (
			this.state.servings !== ''
			&& this.state.servings !== null
			&& this.state.servings !== 0
		)
			? (
				<Row>
					<Col xs={12} style={{ padding: '1em' }}>
						<strong>
							Servings:
						</strong>
						{' '}
						{this.state.servings}
					</Col>
				</Row>
			)
			: null
	}
}



// WEBPACK FOOTER //
// ./src/modules/details/servings.jsx